<template>
  <div>
    <span v-if="value === true">
          <v-badge color="green accent-3"></v-badge>
    </span>
    <span v-else-if="value === false">
      <v-badge color="red accent-3"></v-badge>
    </span>
  </div>
</template>

<script>

export default {
  name: 'BaseBoolIndicator',
  props: ['value'],
}

</script>

<style scoped lang="scss">
</style>
